import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export type TenantTemplateAction = 'create' | 'edit' | 'delete';

/**
 * Navigates to a pre-filled KaaP tenant scaffolder template, passing the form
 * values through the `formData` query param the wizard reads on load.
 */
export const useNavigateToTemplate = () => {
  const navigate = useNavigate();

  return useCallback(
    ({
      formData,
      action,
    }: {
      formData: unknown;
      action: TenantTemplateAction;
    }) => {
      navigate(
        `/create/templates/default/kaap-tenant-${action}?formData=${encodeURIComponent(
          JSON.stringify(formData),
        )}`,
      );
    },
    [navigate],
  );
};
